// extracted by mini-css-extract-plugin
module.exports = {"container":"FuwTabs_container__uxA_D","button":"FuwTabs_button__2UvBR","active":"FuwTabs_active__jTFwU","text":"FuwTabs_text__2phHk"};